import React from 'react';
import Button from '~/components/atom/Button';
import JustificationContainer from '~/components/atom/JustificationContainer';
import { Label } from '~/components/atom/Typography';

const text = {
  addButtonLabel: 'Toevoegen',
};

export type Props = {
  dataTestId?: string;
  className?: string;
  label: string;
  onAddService: () => void;
};

const AddServiceBlock: React.FCC<Props> = ({
  dataTestId,
  className,
  label,
  onAddService,
}) => (
  <JustificationContainer
    data-testid={dataTestId}
    className={className}
    align="center"
    justification="space-between"
    width="100%"
    border={{ width: 's', color: { group: 'tertiary' }, radius: 'base' }}
    padding={['xs', 'm']}
  >
    <Label margin={[null]} size="m" color={{ group: 'secondary' }}>
      {label}
    </Label>
    <Button
      onClick={onAddService}
      appearance="secondary"
      label={text.addButtonLabel}
      icon="plus"
    />
  </JustificationContainer>
);

export default AddServiceBlock;
